import { CloudDownloadOutlined } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';

export default function NoAuthTemplates({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <Box
      component="main"
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#EFF3F8',
      }}
    >
      <Box sx={{ position: 'relative' }}>
        {children}
        <div style={{ display: 'flex', justifyContent: 'end', padding: '0.5rem' }}>
          <Button onClick={() => window.open('/software')} sx={{ display: 'flex', alignItems: 'start', px: 2 }}>
            <CloudDownloadOutlined sx={{ marginRight: 2 }} />
            <Stack>
              <Typography variant="caption" align="left" fontWeight="bold" lineHeight={1.3}>
                Download LogTrack USB Temperature Data Logger PC Tool
              </Typography>
              <Typography variant="caption" align="left">
                (LogTrack Connect)
              </Typography>
            </Stack>
          </Button>
        </div>
        <Typography
          component="footer"
          align="center"
          color="#7F7F7F"
          fontSize={14}
          sx={{ position: 'absolute', bottom: -140, left: 0, right: 0 }}
        >
          Copyright ©m2Cloud Inc. All Rights Reserved.
        </Typography>
      </Box>
    </Box>
  );
}
